import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './auth/AuthContext';
import Login from './pages/Login';
import Pending from './pages/Pending';
import SetName from './pages/SetName';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import TicketNew from './pages/TicketNew';
import TicketDetail from './pages/TicketDetail';
import Positions from './pages/Positions';
import AdminUsers from './pages/AdminUsers';

function RedirectToLogin() {
  const loc = useLocation();
  const next = loc.pathname + loc.search;
  const safeNext = next === '/login' ? '/' : next;
  return <Navigate to={`/login?next=${encodeURIComponent(safeNext)}`} replace />;
}

function RedirectToSetName() {
  const loc = useLocation();
  const next = loc.pathname + loc.search;
  if (loc.pathname === '/set-name') return null;
  return <Navigate to={`/set-name?next=${encodeURIComponent(next)}`} replace />;
}

function RedirectToPending() {
  const loc = useLocation();
  const next = loc.pathname + loc.search;
  if (loc.pathname === '/pending') return null;
  return <Navigate to={`/pending?next=${encodeURIComponent(next)}`} replace />;
}

function GateRoutes() {
  const { user, loading } = useAuth();
  if (loading) {
    return <div className="min-h-full flex items-center justify-center text-zinc-500">Loading…</div>;
  }
  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<RedirectToLogin />} />
      </Routes>
    );
  }
  if (!user.name || user.name.trim().length === 0) {
    return (
      <Routes>
        <Route path="/set-name" element={<SetName />} />
        <Route path="*" element={<RedirectToSetName />} />
      </Routes>
    );
  }
  if (user.status !== 'ACTIVE') {
    return (
      <Routes>
        <Route path="/pending" element={<Pending />} />
        <Route path="*" element={<RedirectToPending />} />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/tickets/new" element={<TicketNew />} />
        <Route path="/tickets/:id" element={<TicketDetail />} />
        <Route path="/positions" element={<Positions />} />
        {user.role === 'ADMIN' && <Route path="/admin/users" element={<AdminUsers />} />}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <GateRoutes />
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </AuthProvider>
  );
}
